import type { FragmentType } from '@packages/gql/generated/shopping';
import type { RecoProductCardFragmentDoc } from '@packages/gql/generated/shopping/RecoProductCardFragmentDoc';
import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import type { GTMEventGlycerinDisplayRecommendation } from '@packages/tracking/src/types/events';
import { useEffect } from 'react';
import { getProductGlycerinTiles } from '../../helpers/getProductGlycerinTiles';
import type { PageTemplate, RdeType, RecoSliderProps } from '../../types';

export type TrackingProps = {
  pageTemplate: PageTemplate;
  rdeType: RdeType;
  rdeTypeAbbr?: string;
  recommendations?: Array<FragmentType<typeof RecoProductCardFragmentDoc>>;
  title: string;
  trackingCondition: boolean;
} & Pick<RecoSliderProps, 'onSeen'>;

export const useProductsRecoTracking = ({
  pageTemplate,
  rdeType,
  rdeTypeAbbr,
  recommendations,
  title,
  trackingCondition,
  onSeen,
}: TrackingProps) => {
  const dispatchGTMEvent = useTracking();

  useEffect(() => {
    if (trackingCondition && recommendations !== undefined && rdeTypeAbbr) {
      // seen tracking
      onSeen?.();

      // glycerin seen tracking
      dispatchGTMEvent<GTMEventGlycerinDisplayRecommendation>({
        event: 'DisplayRecommendation',
        DisplayRecommendationData: {
          name: title,
          // TODO: add placement as prop in trackingProps -> https://empiriecom.atlassian.net/browse/INFORM-2616
          // placement: GlycerinPlacement.CONTENT,
          recoId: rdeTypeAbbr,
          recoType: 'carousel',
          strategy: rdeType,
          tiles: getProductGlycerinTiles(recommendations, rdeTypeAbbr),
          totalSize: recommendations.length,
        },
      });
    }
  }, [
    dispatchGTMEvent,
    pageTemplate,
    rdeType,
    rdeTypeAbbr,
    recommendations,
    title,
    trackingCondition,
    onSeen,
  ]);
};
